import { render, staticRenderFns } from "./PadPage.vue?vue&type=template&id=3e4a695c&scoped=true"
import script from "./PadPage.vue?vue&type=script&lang=js"
export * from "./PadPage.vue?vue&type=script&lang=js"
import style0 from "./PadPage.vue?vue&type=style&index=0&id=3e4a695c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4a695c",
  null
  
)

export default component.exports